class ContextualFilterBase {
    filter(results, session, league) {
        throw new Error('not implemented');
    }
}

export default ContextualFilterBase;